import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import redirect from 'actions/redirect';

class CreateButton extends React.Component {
  handleClick() {
    this.props.redirect('/track-template-edit/create/'
      + 'track-id/'+ this.props.trackId + '/'
      + 'recorder-id/'+ this.props.recorderId
    );
  }

  render() {
    return <ul className="nav navbar-nav navbar-right">
      <li><a href="#" onClick={ this.handleClick.bind(this) }>
        <span
          className="glyphicon glyphicon-plus"
          aria-hidden="true">
        </span>
      </a></li>
    </ul>;
  }
}

function mapStateToProps(state) {
  return {
    recorderId: state.track.data.recorderId
  }
}

function mapDispatchToProps(dispatch) {
  return {
    redirect: bindActionCreators(redirect, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateButton);
